import Vue from 'vue'

// Sharing carries references and the visible page context; access is always
// evaluated again by Laravel when a recipient opens the card.
export const chatSharing = new Vue()

const sensitiveKey = /^(?:__proto__|constructor|prototype|fromScenario|authorization|cookie|password|password_confirmation|token|access_token|refresh_token|api_token|api_key|secret)$/i
const plainObject = value => value !== null && typeof value === 'object' && !Array.isArray(value)

const unavailablePreviewModules = new Set(['ventilation', 'geoloc', 'codebarre', 'historiqueemail', 'analyseemail', 'fjours', 'mailbox'])
export const canPreviewModule = component => !unavailablePreviewModules.has(component)

export function cleanResourceContext(value, depth = 0, seen = new WeakSet()) {
  if (depth > 12) return undefined
  if (value === null || typeof value === 'boolean' || typeof value === 'number') return value
  if (typeof value === 'string') return value.slice(0, 16384)
  if (typeof value !== 'object' || seen.has(value)) return undefined
  seen.add(value)
  const result = Array.isArray(value) ? [] : {}
  Object.keys(value).slice(0, 500).forEach(key => {
    if (sensitiveKey.test(key) || key === 'action' || key === 'actions') return
    const entry = cleanResourceContext(value[key], depth + 1, seen)
    if (entry !== undefined) result[key] = entry
  })
  seen.delete(value)
  return result
}

export function captureChatResource(store, modalKey, reference = {}) {
  const user = store.getters.currentUser || {}
  if (reference.type === 'field') {
    return cleanResourceContext({ type: 'field', entreprise_id: Number(user.cpnID || user.entreprise_id) || undefined,
      context: { field_id: reference.context && reference.context.field_id } })
  }
  const page = store.getters.specificPage(modalKey) || {}
  const extra = plainObject(reference.context) ? reference.context : {}
  const params = { ...(plainObject(page.params) ? page.params : {}), ...(plainObject(extra.params) ? extra.params : {}) }
  const querys = { ...(plainObject(page.querys) ? page.querys : {}), ...(plainObject(extra.querys) ? extra.querys : {}) }
  const context = cleanResourceContext({ ...extra, params, querys })
  const result = {
    ...reference,
    type: reference.type || 'module',
    entreprise_id: Number(user.cpnID || user.entreprise_id) || undefined,
    page_id: reference.page_id || page.idpage || undefined,
    row_id: reference.row_id || (extra.row && (extra.row.id || extra.row.event_key)) || undefined,
    context
  }
  delete result.modalKey
  delete result.params
  delete result.querys
  return cleanResourceContext(result)
}

export function requestChatShare(store, modalKey, reference, mode = 'existing') {
  const captured = captureChatResource(store, modalKey, reference)
  chatSharing.$emit('share', { reference: captured, mode })
  return captured
}

export function resourceIcon(type, moduleType) {
  if (type && typeof type === 'object') {
    moduleType = type.module_type || type.payload && type.payload.module && type.payload.module.type || type.context && type.context.module_type
    type = type.type
  }
  if (type === 'action') return 'mdi-lightning-bolt-outline'
  if (type === 'page') return 'mdi-file-document-outline'
  if (type === 'tab') return 'mdi-tab'
  if (type === 'visual') return 'mdi-view-dashboard-outline'
  if (type === 'field') return 'mdi-form-textbox'
  return ({ pdf: 'mdi-file-pdf-box', table: 'mdi-table-large', tabs: 'mdi-tab', form: 'mdi-form-select', calendar: 'mdi-calendar-month-outline', planning: 'mdi-calendar-clock', ged: 'mdi-folder-outline', echarts: 'mdi-chart-bar', map: 'mdi-map-outline' })[moduleType] || 'mdi-view-module-outline'
}

export function resourceTypeLabel(type) {
  if (type && typeof type === 'object') type = type.type
  return ({ page: 'Page', module: 'Module', action: 'Action', tab: 'Tabulation', visual: 'Visuel', field: 'Champ', document: 'Document' })[type] || 'Ressource'
}

export function disposeResourceContext(store, modalKey) {
  store.dispatch('removeModalContext', modalKey)
}
